<script setup lang="ts">
import Information from "@/views/playground/planner/business-management/service-management/information/Information.vue";
</script>

<template>
  <information></information>
</template>

<style scoped></style>
